/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Bar from "../../Charts/Bar";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { ExportChartWrapper } from "../styles/total-jobs-per-sector-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";

export interface ITotalJobsPerSectorPdfExportProps {
  totalJobsPerSectorPdfExport: {
    sectors?: Array<string>;
    values?: Array<number>;
  };
  totalJobsPerSectorWidgetLoader: boolean;
}

export class TotalJobsPerSectorPdfExport extends Component<
  ITotalJobsPerSectorPdfExportProps,
  unknown
> {
  static propTypes = {
    totalJobsPerSectorPdfExport: PropTypes.shape({
      sectors: PropTypes.arrayOf(PropTypes.string),
      values: PropTypes.arrayOf(PropTypes.number),
    }).isRequired,
    totalJobsPerSectorWidgetLoader: PropTypes.bool.isRequired,
  };

  state = {};

  render(): ReactNode {
    const { totalJobsPerSectorPdfExport, totalJobsPerSectorWidgetLoader } =
      this.props;

    const totalJobsPerSectorPdfExportOptions = {
      series: [
        {
          data: totalJobsPerSectorPdfExport.values,
        },
      ],
      options: {
        colors: ["#775dd0"],
        chart: {
          toolbar: {
            show: false,
          },
          height: "100%",
        },
        dataLabels: {
          enabled: true,
          formatter: (val: number) => val,
          offsetX: 15,
          offsetY: 0,
          style: {
            fontSize: "11px",
            colors: ["#333"],
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "right",
            },
          },
        },
        xaxis: {
          categories: totalJobsPerSectorPdfExport.sectors,
        },
      },
    };

    return (
      <Fragment>
        <ExportChartWrapper>
          <AnalyticsWidgetLoading
            text="Updating..."
            active={totalJobsPerSectorWidgetLoader}
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="total-jobs-per-sector-chart-title"
          >
            Total Jobs per Sector
          </ChartTitle>
          <Bar
            height={270}
            width={450}
            graphOptions={totalJobsPerSectorPdfExportOptions}
            dataTestId="total-jobs-per-sector-chart"
          />
        </ExportChartWrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    chartsData: {
      totalJobsPerSector: unknown;
    };
    totalJobsPerSectorWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  totalJobsPerSectorPdfExport:
    state.employerAnalytics.chartsData.totalJobsPerSector,
  totalJobsPerSectorWidgetLoader:
    state.employerAnalytics.totalJobsPerSectorWidgetLoader,
});

export default connect(mapStateToProps, {})(TotalJobsPerSectorPdfExport);
